var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewHarvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.571952 4.39344L4.2603 0L7.16155 3.26067L6.18289 7.98132C5.84788 8.45665 5.59941 8.99735 5.4604 9.58051H4.24648L3.89891 6.91126L5.98796 3.18602L4.41462 1.28474L5.18836 3.10886L3.50255 5.78102L1.34554 5.0229L3.1638 6.8985L3.17657 9.58051H1.5717L0.571952 4.39344Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36554 10.1155H0.975986L0.968743 10.1162C-0.377259 10.7378 -0.288951 12.6539 1.03674 13.3252H6.16414C5.64034 12.5709 5.33333 11.6546 5.33333 10.6667C5.33333 10.4802 5.34427 10.2962 5.36554 10.1155Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87415 14.1318H6.05928C6.01456 14.302 5.95372 14.4698 5.89477 14.6325C5.81742 14.8459 5.74332 15.0503 5.71313 15.2393L6.38631 16H7.99119L8.22941 14.9857C8.01356 14.8971 7.80581 14.7928 7.60759 14.6743L7.50004 14.9858L7.48344 14.5973C7.26753 14.4588 7.06378 14.303 6.87415 14.1318Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21251 6.06616L8.24312 4.71692L7.1586 6.52707C7.20378 6.65347 7.24659 6.76547 7.28803 6.86846C7.84953 6.46682 8.50381 6.1866 9.21251 6.06616Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88838 7.18874C6.86252 7.13816 6.84736 7.10862 6.84736 7.10862L6.82093 7.25031C6.84321 7.22957 6.8657 7.20904 6.88838 7.18874Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08359 14.131L2.64161 16H5.3164L5.62173 14.1358L4.77449 14.1258L4.38154 15.7686L3.80632 14.1372L2.08359 14.131Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 16C13.6122 16 16 13.6122 16 10.6667C16 7.72115 13.6122 5.33333 10.6667 5.33333C7.72115 5.33333 5.33333 7.72115 5.33333 10.6667C5.33333 13.6122 7.72115 16 10.6667 16ZM10.6667 15.3333C13.244 15.3333 15.3333 13.244 15.3333 10.6667C15.3333 8.08934 13.244 6 10.6667 6C8.08934 6 6 8.08934 6 10.6667C6 13.244 8.08934 15.3333 10.6667 15.3333Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.33333H11.3333V14H10V7.33333Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 10H14V11.3333H7.33333V10Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHarvest);
export default __webpack_public_path__ + "static/media/NewHarvest.ac1d018d176a5c87aba8f9ac6a4e7b49.svg";
export { ForwardRef as ReactComponent };